import { Skeleton } from "@/app/components/shadcn/skeleton";

const SearchAndSortSkeleton = () => {
  return (
    <div className="flex gap-4">
      <div className="relative flex-1">
        <Skeleton className="h-10 w-full" />
      </div>
      <Skeleton className="h-10 w-48" />
    </div>
  );
};

export default SearchAndSortSkeleton;